import * as React from 'react';
import { useFela } from 'react-fela';
import { createBoxModelCSSProps, createFlexChildCSSProps, createFontCSSProps, createMarginCSSProps, createPaddingCSSProps, createStylingCSSProps, } from './base';
import { createResponsiveStyles } from './utils';
export function createBoxCSSStyle(props, theme, outsideMediaQuery) {
    return {
        ...createBoxModelCSSProps(props),
        ...createMarginCSSProps(props, theme),
        ...createPaddingCSSProps(props, theme),
        ...createFlexChildCSSProps(props, theme, outsideMediaQuery),
        ...createStylingCSSProps(props, theme),
        ...createFontCSSProps(props, theme),
    };
}
export function Box(props) {
    const { as = 'div', style, onClick, onMouseDown, onMouseOut, onMouseOver, onScroll, htmlAttrs, testId, innerRef, children, ...styleProps } = props;
    const { css, theme } = useFela();
    const boxStyles = createResponsiveStyles(styleProps, createBoxCSSStyle, theme);
    return React.createElement(as, {
        className: css([boxStyles, style]),
        'data-testid': testId,
        onClick,
        onMouseDown,
        onMouseOut,
        onMouseOver,
        onScroll,
        ...htmlAttrs,
        ref: innerRef,
    }, children);
}
export function HeaderBox(props) {
    return React.createElement(Box, { as: "header", ...props });
}
export function NavBox(props) {
    return React.createElement(Box, { as: "nav", ...props });
}
export function SectionBox(props) {
    return React.createElement(Box, { as: "section", ...props });
}
export function ArticleBox(props) {
    return React.createElement(Box, { as: "article", ...props });
}
export function AsideBox(props) {
    return React.createElement(Box, { as: "aside", ...props });
}
export function FooterBox(props) {
    return React.createElement(Box, { as: "footer", ...props });
}
export function FigCaptionBox(props) {
    return React.createElement(Box, { as: "figcaption", ...props });
}
export function FigureBox(props) {
    return React.createElement(Box, { as: "figure", ...props });
}
//# sourceMappingURL=Box.js.map